import { ReactComponent as Alert } from "../../../assets/svg/alert.svg";
import { SideResponse } from "../../../codegen-api";
import { COLORS } from "../../../constants/design/colors";
import { SPACING } from "../../../constants/design/spacing";
import {
  InfoRow,
  PositionChip,
  PositionInfoWrapper,
  Title,
  TradeInfoWrapper,
  Value,
} from "../style";
import { ExtraFarmBoostDetails } from "../ExtraFarmBoostDetails";
import { useOptionsTradeFormSetup } from "./useOptionsTradeFormSetup";
import { useOptionsTradeFormComputed } from "./useOptionsTradeFormComputed";
import { useOptionsTradeFormPosition } from "./useOptionsTradeFormPosition";

type SetupResult = ReturnType<typeof useOptionsTradeFormSetup>;
type ComputedResult = ReturnType<typeof useOptionsTradeFormComputed>;
type PositionResult = ReturnType<typeof useOptionsTradeFormPosition>;

type InfoSectionProps = Pick<SetupResult, "optionsTradeFormTranslations"> &
  Pick<ComputedResult, "bottomTradeInfo"> &
  Pick<PositionResult, "positionInfo">;

export function InfoSection({
  positionInfo,
  optionsTradeFormTranslations,
  bottomTradeInfo,
}: InfoSectionProps) {
  return (
    <>
      <PositionInfoWrapper>
        {positionInfo.map((info) => (
          <InfoRow
            key={`${info.title}-${info.value}}`}
            warningOrError={info.warningOrError}
          >
            <Title>
              {info.title}
              {Boolean(info.warningOrError && info.showErrorIcon) && (
                <Alert
                  style={{
                    stroke:
                      info.warningOrError === "warning"
                        ? COLORS.system.one
                        : COLORS.negative.one,
                    marginLeft: `${SPACING.one}px`,
                    marginTop: `-${SPACING.one / 2}px`,
                  }}
                />
              )}
              {info.side && (
                <PositionChip $type={info.side}>
                  {info.side === SideResponse.Buy
                    ? optionsTradeFormTranslations("long")
                    : optionsTradeFormTranslations("short")}
                </PositionChip>
              )}
            </Title>
            <Value>{info.value}</Value>
          </InfoRow>
        ))}
      </PositionInfoWrapper>
      <TradeInfoWrapper>
        {bottomTradeInfo.map((info) => (
          <InfoRow
            key={info.key ?? `${info.title}-${info.value}`}
            warningOrError={info.warningOrError}
            marginBottom={SPACING.two}
          >
            <Title>
              {info.title}
              {Boolean(info.warningOrError && info.showErrorIcon) && (
                <Alert
                  style={{
                    stroke:
                      info.warningOrError === "warning"
                        ? COLORS.system.one
                        : COLORS.negative.one,
                    marginLeft: `${SPACING.one}px`,
                    marginTop: `-${SPACING.one / 2}px`,
                  }}
                />
              )}
            </Title>
            <Value>{info.value}</Value>
          </InfoRow>
        ))}
      </TradeInfoWrapper>
      <ExtraFarmBoostDetails />
    </>
  );
}
